import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';


const containers = document.querySelectorAll('[data-zodiac-embed]');
containers.forEach(container => {
    const root = ReactDOM.createRoot(container);
    root.render(<App />);
})